<template>
    <div style="width: 800px;margin: 30px auto">
        <div style="margin: 10px auto 30px 50px">
            <a style="font-size: 20px;color:#407338">Transcription factor gene-family {{subfamily}} in <i>B. rapa</i></a>
        </div>
        <el-table
            ref="filterTable"
            :data="SearchTranscriptionFactorGene_list"
            height="580px"
            line-hight="10px"
            border
            header-cell-style="color:#407338;text-align:center"
            :row-style="{height:'35px'}"
            cell-style="color:#407338;text-align:center">
            <el-table-column prop="bgene" label="Gene (B. rapa)" width="200px">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleBraGene(scope.row)" style="color: #3742fa">{{scope.row.bgene}}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="idpfam" label="ID Pfam" width="160px">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="search_Pfam(scope.row)" style="color: #3742fa">{{scope.row.idpfam}}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="domain" label="Domain" width="120px"></el-table-column>
            <el-table-column prop="pfamval" label="e-value Pfam" width="160px"></el-table-column>
            <el-table-column prop="family" label="Family" width="140px"></el-table-column>
        </el-table>
        <div style="margin: 10px auto 10px 50px">
            <FunctionSelection v-if="boxtarget" :target="selection_gene"
                @hideBox="hideSelectionBox"
                @watchSubFunction="common.searchSubFunction"></FunctionSelection>
            <FucntionSelectionBra v-if="Bra_boxtarget" :target="selection_gene"
                @hideBox="hideBraSelectionBox"
                @watchSubFunctionBra="common.searchSubFunction"></FucntionSelectionBra>
            <FunctionSelectionAth10 v-if="Ath_boxtarget" :target="selection_gene"
                @hideBox="hideAth10SelectionBox"
                @watchSUbFunctionAth10="common.searchSubFunction"></FunctionSelectionAth10>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import FunctionSelection from "../components/FunctionSelection";
    import FucntionSelectionBra from "../components/FucntionSelectionBra";
    import FunctionSelectionAth10 from "../components/FunctionSelectionAth10";
    export default {
        name: "SearchTranscriptionFactorGene",
        data() {
            return {
                subfamily:this.$route.query.subfamily,
                SearchTranscriptionFactorGene_list: '',
                boxtarget: 0,
                Bra_boxtarget: 0,
                Ath_boxtarget: 0,
                selection_gene: '',
            }
        },
        mounted() {
            this.get_AimSearchTranscriptionFactorGene_list()
        },
        components: {
            FunctionSelection,
            FucntionSelectionBra,
            FunctionSelectionAth10
        },
        methods: {
            get_AimSearchTranscriptionFactorGene_list() {
                var subfamily = this.subfamily;
                axios({
                    url:'http://39.100.233.196:8001/api/get-aim-transcriptionFactor-gene/',
                    type:'json',
                    params: {
                        subfamily
                    },
                    method:'get',
                }).then((res)=>{
                    this.SearchTranscriptionFactorGene_list = res.data
                    // console.log(this.SearchTranscriptionFactorGene_list)
                })
            },
            resetSubfamilyFilter() {
                this.$refs.filterTable.clearFilter('symgene');
            },
            search_Pfam(row) {
                // console.log(row.idpfam);
                window.open('http://pfam.xfam.org/family/' + row.idpfam);
            },
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },
            handleAtnGene(row) {
                // console.log(row.bnsgene)
                this.selection_gene = row.bnsgene.split(' ')[0]
                this.Ath_boxtarget = 1;
                this.boxtarget = 0;
                this.Bra_boxtarget = 0;
            },
            handleAtGene(row) {
                // console.log(row.agene)
                this.selection_gene = row.agene.split(' ')[0]
                this.Ath_boxtarget = 1;
                this.boxtarget = 0;
                this.Bra_boxtarget = 0;
            },
            handleBraGene(row) {
                // console.log(row.bgene.split(' ')[0])
                this.selection_gene = row.bgene.split(' ')[0]
                this.boxtarget = 0;
                this.Bra_boxtarget = 1;
                this.Ath_boxtarget = 0;
            },
            hideSelectionBox() {
                this.boxtarget = 0;
            },
            hideBraSelectionBox () {
                this.Bra_boxtarget = 0;
            },
            hideAth10SelectionBox () {
                this.Ath_boxtarget = 0;
            },
        },
    }
</script>

<style>

</style>